import React, { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { DiagnosticRTCProvider } from '@/providers/diagnosticRTC/DiagnosticRTCProvider'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAccessToken, setAccessToken } from '@/redux/reducers/auth.reducer'
import { getConsultation, getStunServer, selectAttendeeInfo, selectConsultationById, selectMeetingInfo, selectTwilioStunServer } from '@/redux/reducers/consultation.reducer'
import { selectCustomDevices } from '@/redux/reducers/custom-device.reducer'
import { getCustomDevices } from '@/redux/reducers/custom-device.reducer'
import { getRoom, selectRoomByConsultationId } from '@/redux/reducers/room.reducer'

import DiagnosticMedicalVideo from '@/pages/diagnostic/containers/DiagnosticMedicalVideo'

export function MedicalVideoPage() {
  const dispatch = useAppDispatch()
  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation()

  const consultationId = searchParams.get('consultationId')

  // const rpiMeetingId = useAppSelector(selectRpiMeetingId)
  const medicalVideoAttendeeInfo = useAppSelector((state) => selectAttendeeInfo(state, 'medicalVideo'))
  const medicalVideoMeetingInfo = useAppSelector((state) => selectMeetingInfo(state, 'medicalVideo'))

  const accessToken = useAppSelector(selectAccessToken)
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))
  const customDevices = useAppSelector(selectCustomDevices)
  const room = useAppSelector((state) => (consultationId ? selectRoomByConsultationId(state, consultationId) : undefined))
  const twilioStunServer = useAppSelector(selectTwilioStunServer)

  const peerConfig = useMemo(
    () =>
      !twilioStunServer
        ? undefined
        : {
          iceServers: twilioStunServer.iceServers,
        },
    [twilioStunServer]
  )

  // const rpiMeetingIde = useMemo(
  //   () =>
  //     !rpiMeetingId
  //       ? undefined
  //       : {
  //           meetingID: rpiMeetingId,
  //           serverUrl: getEnv('VITE_RPI_GATEWAY')!,
  //         },
  //   [rpiMeetingId]
  // )

  useEffect(() => {
    const accessToken = searchParams.get('accessToken')
    if (!accessToken) return
    dispatch(setAccessToken(accessToken))
    searchParams.delete('accessToken')
    setSearchParams(searchParams.toString())
  }, [dispatch, searchParams, setSearchParams])

  useEffect(() => {
    if (accessToken && consultationId) {
      dispatch(getConsultation(consultationId))
      dispatch(getRoom(consultationId))
    }
  }, [accessToken, dispatch, consultationId])

  useEffect(() => {
    if (!accessToken) return
    dispatch(getCustomDevices())
    dispatch(getStunServer())
    // dispatch(getRpiMeetingId())
  }, [accessToken, dispatch])

  if (!consultationId) return null

  if (!consultation || !room) {
    return (
      <Box
        sx={{ width: '100%', minHeight: '100vh', minWidth: '100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
      >
        <CircularProgress size="3rem" />
        <Typography fontWeight="bold" margin="50px">
          {t('common:loading')} ...
        </Typography>
      </Box>
    )
  }

  const peerjsConfig = {
    config: peerConfig,
    peerId: room.streamer,
    streamer: room.streamer,
  }

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', minWidth: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <DiagnosticRTCProvider
        config={{
          chime: {
            attendeeInfo: medicalVideoAttendeeInfo,
            meetingInfo: medicalVideoMeetingInfo,
          },
          peerjs: peerjsConfig,
          // rpi: rpiMeetingIde,
        }}
        customDevices={customDevices}
        isStreamer
        type="video"
      >
        <DiagnosticMedicalVideo videoHeight="100vh" videoWidth="100vw" consultationId={consultationId} disableStreamOnMobile />
      </DiagnosticRTCProvider>
    </Box>
  )
}

export default MedicalVideoPage
